"use client";
import { ProcessedCourse } from "@/common/course/types";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Markdown from "react-markdown";

interface FAQsProps {
  course: ProcessedCourse;
  title?: string;
  data?: {
    question: string;
    answer: string;
  }[];
}

const defaultFaqs = [
  {
    question: "How will I learn?",
    answer:
      "This program combines video lectures, interactive exercises, case studies, and peer discussions. You'll learn through a mix of self-paced content and live sessions with instructors and fellow learners.",
  },
  {
    question: "Who is my success team?",
    answer:
      "Your success team includes dedicated program advisors, technical support staff, and peer mentors who are available to help you throughout your learning journey. You'll also have access to the instructor team for academic guidance.",
  },
  {
    question: "What are the technical requirements?",
    answer:
      "You'll need a computer with a stable internet connection, a modern web browser (Chrome, Firefox, Safari, or Edge), and basic software like a PDF reader. Specific technical requirements will be provided upon enrollment.",
  },
];

export default function FAQs({
  course,
  title = "Frequently asked questions",
  data,
}: FAQsProps) {
  const faqs = data || defaultFaqs;
  return (
    <section id="faqs">
      <h2 className="mb-8 text-3xl font-bold">{title}</h2>
      <Accordion type="single" collapsible className="space-y-4">
        {faqs.map((faq, index) => (
          <AccordionItem
            key={index}
            value={`item-${index}`}
            className="rounded-xs border bg-white p-2 [&>h3]:p-2 [&>h3]:m-0 [&_button]:p-0 [&_button]:m-0"
          >
            <AccordionTrigger className="text-left font-semibold hover:no-underline p-0! ">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground [&>p]:text-xs p-4">
              <Markdown>{faq.answer}</Markdown>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
